import { render, staticRenderFns } from "./RefsOutputAccordionPagination.vue?vue&type=template&id=edcb1fa2&"
import script from "./RefsOutputAccordionPagination.vue?vue&type=script&lang=js&"
export * from "./RefsOutputAccordionPagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports